import React from 'react'
import { useNode } from 'react-pagebuilder/hooks/useNode'
import { useEditor } from 'react-pagebuilder/hooks/useEditor'
import { Accordion as Original } from 'components/atoms'
import { AccordionSettings, AccordionFloatingSettings } from './AccordionSettings'
import { withBlock } from '../withBlock'
import { withCraft } from '../withCraft'
import { getTextEditor } from '../TextEditor'

export const defaultProps = {
  label: 'Label',
}

export const dynamicProps = []

export const Accordion: any = withBlock(
  (props) => {
    const blockProps = {
      ...defaultProps,
      ...props.block,
    }

    const { children } = props

    const _ = props.renderValue

    const {
      id,
      connectors: { connect },
      selected,
      hovered,
      actions: { setProp, setCustom },
      customs,
    } = useNode(
      (state) => ({
        selected: state.events.selected,
        dragged: state.events.dragged,
        hovered: state.events.hovered,
        customs: state.data.custom,
      }),
      props
    )

    const { enabled } = useEditor(
      (state) => ({
        enabled: state.options.enabled,
      }),
      props
    )

    return (
      <div ref={(ref) => props.retRef(ref)} className={`block-accordion ${props.className}`}>
        <Original id={id} label={blockProps.label} editMode={enabled}>
          {enabled ? (
            getTextEditor(children?.[0], enabled)
          ) : (
            <div
              className="block-accordion__content"
              dangerouslySetInnerHTML={{ __html: getTextEditor(children?.[0], enabled) }}
            />
          )}
        </Original>
      </div>
    )
  },
  defaultProps,
  dynamicProps
)

Accordion.craft = withCraft({
  name: 'Accordion',
  defaultProps: defaultProps,
  settings: AccordionSettings,
  floatingSettings: AccordionFloatingSettings,
})
